import config from "./config";

export const meetingOperationId = () => crypto.randomUUID().replace(/-/g, "");
export async function meetingApi(path = "", method = "GET", body, signal) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener("abort", abort);
  const timeout = setTimeout(abort, 30000);
  try {
    const response = await fetch(`${config.API_URL.replace(/\/$/, "")}/api/meetings${path}`, {
      method, signal: controller.signal,
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(response.status === 401 ? "Sign in again to access your meetings."
        : data.message || "Meetings are unavailable. Please try again.");
      error.status = response.status;
      throw error;
    }
    return data;
  } finally { clearTimeout(timeout); signal?.removeEventListener("abort", abort); }
}

export const meetingInvitationKey = "signalTunerMeetingInvitation";
export function pendingMeetingInvitation() {
  try {
    const value = JSON.parse(sessionStorage.getItem(meetingInvitationKey));
    return /^[a-f0-9]{32}$/.test(value?.token) && value.expires > Date.now() ? value : null;
  } catch { return null; }
}
